import { Product } from '@/lib/data'
import { Card, CardContent, CardFooter } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { useCart } from '@/contexts/CartContext'
import { gtmEvents } from '@/lib/gtm'

interface ProductCardProps {
  product: Product
}

export const ProductCard = ({ product }: ProductCardProps) => {
  const { addToCart } = useCart()

  const handleClick = () => {
    gtmEvents.selectItem({
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      item_category: product.category,
    })
  }

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault() // Prevent navigation
    e.stopPropagation()
    addToCart(product, 1)
  }

  return (
    <Card className="group overflow-hidden transition-all hover:-translate-y-1 hover:shadow-lg">
      <Link to={`/produto/${product.id}`} onClick={handleClick}>
        <div className="aspect-square overflow-hidden bg-slate-50 relative">
          <img
            src={product.image}
            alt={product.name}
            className="h-full w-full object-cover transition-transform group-hover:scale-105 duration-500"
            loading="lazy"
          />
        </div>
        <CardContent className="p-4">
          <div className="text-xs text-muted-foreground mb-2 font-medium uppercase tracking-wider">
            {product.category}
          </div>
          <h3 className="font-semibold text-lg leading-tight mb-2 line-clamp-2 min-h-[3rem]">
            {product.name}
          </h3>
          <p className="font-bold text-xl text-primary">
            R$ {product.price.toFixed(2).replace('.', ',')}
          </p>
        </CardContent>
      </Link>
      <CardFooter className="p-4 pt-0">
        <Button
          onClick={handleAddToCart}
          className="w-full"
          variant="secondary"
        >
          Adicionar ao Carrinho
        </Button>
      </CardFooter>
    </Card>
  )
}
